/** Read every page or fail; an incomplete admin catalog must not look complete. */
export async function readAllAdminPages<T extends { id: string }>(
  readPage: (page: number) => Promise<unknown>,
): Promise<T[]> {
  const rows: T[] = [];
  const ids = new Set<string>();
  let page = 1;
  let totalPages = 1;
  let expectedTotal = 0;

  do {
    const response = await readPage(page);
    if (!response || typeof response !== 'object') {
      throw new Error('Resposta administrativa inválida.');
    }
    const result = response as {
      data?: unknown;
      meta?: unknown;
      success?: boolean;
    };
    const meta = result.meta as
      | { page?: unknown; totalPages?: unknown; total?: unknown }
      | undefined;
    const responsePage = Number(meta?.page);
    totalPages = Number(meta?.totalPages);
    expectedTotal = Number(meta?.total);
    if (
      result.success === false ||
      !Array.isArray(result.data) ||
      responsePage !== page ||
      !Number.isInteger(totalPages) ||
      totalPages < 0 ||
      !Number.isInteger(expectedTotal) ||
      expectedTotal < 0 ||
      (page > totalPages &&
        !(page === 1 && totalPages === 0 && expectedTotal === 0)) ||
      (page < totalPages && result.data.length === 0)
    ) {
      throw new Error('Paginação administrativa inválida.');
    }
    for (const item of result.data) {
      if (
        !item ||
        typeof item.id !== 'string' ||
        !item.id ||
        ids.has(item.id)
      ) {
        throw new Error('Catálogo administrativo incompleto ou duplicado.');
      }
      ids.add(item.id);
      rows.push(item as T);
    }
    page += 1;
  } while (page <= totalPages);

  if (rows.length !== expectedTotal) {
    throw new Error('Catálogo administrativo incompleto.');
  }
  return rows;
}
